<div *ngIf="isSingle">
  <div class="ranges-other" fxLayout="row" fxFlex="45" fxLayout.sm="column">
    <div
      class="inputs"
      [fxFlex]="100"
      fxLayout="row wrap"
      fxLayoutAlign="center center"
    >
      <div class="block-add" fxFlex="100">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>بازه</mat-label>
          <input
            [formControl]="rangeFormControl"
            type="text"
            #inputRange
            matInput
          />
        </mat-form-field>
        <button
          class="add-button"
          (click)="addNewItem(inputRange.value)"
          mat-icon-button
          color="primary"
        >
          <jam-icon name="plus" [size]="30"></jam-icon>
        </button>
      </div>

      <div class="single-block-add" fxFlex="100">
        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>تک برگ</mat-label>
          <input
            [formControl]="singleFormControl"
            #inputSingle
            type="number"
            matInput
          />
        </mat-form-field>
        <button
          (click)="addNewItem(+inputSingle.value)"
          class="add-button"
          mat-icon-button
          color="primary"
        >
          <jam-icon name="plus" [size]="30"></jam-icon>
        </button>
      </div>
    </div>
  </div>

  <mat-chip-list class="item-list" fxFlex="55" fxFlex.sm="100" fxFlex.xs="100">
    <span class="placeholder">{{ placeholder }}</span>
    <mat-chip *ngFor="let item of items; index as i" (click)="removeItem(i)">
      {{
        item.start === item.end
          ? item.start.toString()
          : (item.start + "-" + item.end | digitsEnToFa)
      }}
    </mat-chip>
  </mat-chip-list>
</div>

<div *ngIf="!isSingle">
  <div fxLayout="row wrap" fxLayoutAlign="stretch">
    <div class="mini-block" fxFlex="100" fxLayout="column">
      <!-- Block selected list items -->
      <mat-chip-list
        class="item-list"
        fxFlex="100"
        fxFlex.sm="100"
        fxFlex.xs="100"
      >
        <span class="placeholder">{{ placeholder }}</span>
        <mat-chip
          *ngFor="let item of items; index as i"
          (click)="removeItem(i)"
        >
          {{
            item.start === item.end
              ? toFaCharacters(item.start + "")
              : (toFaCharacters(item.start + "-" + item.end) | digitsEnToFa)
          }}
        </mat-chip>
        <button
          #addBtnOverlay
          (click)="toggleInputOverlay()"
          class="add-btn"
          mat-icon-button
        >
          <jam-icon name="plus" [size]="30"></jam-icon>
        </button>
      </mat-chip-list>

      <div class="floated-add-input" @overlayFade *ngIf="addInputOpen">
        <div
          class="inputs"
          fxFlex="80"
          fxLayout="row wrap"
          fxLayoutAlign="center center"
        >
          <!-- range input-------------------------------- -->
          <div class="block-add" fxFlex="100">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>بازه</mat-label>
              <input
                [formControl]="rangeFormControl"
                type="text"
                #inputRange
                matInput
              />
            </mat-form-field>
            <button
              class="add-button"
              (click)="addNewItem(inputRange.value)"
              mat-icon-button
              color="primary"
            >
              <jam-icon name="plus" [size]="30"></jam-icon>
            </button>
          </div>

          <!-- Single page input-------------------------- -->
          <div class="single-block-add" fxFlex="100">
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>تک برگ</mat-label>
              <input
                [formControl]="singleFormControl"
                #inputSingle
                type="number"
                matInput
              />
            </mat-form-field>
            <button
              (click)="addNewItem(+inputSingle.value)"
              class="add-button"
              mat-icon-button
              color="primary"
            >
              <jam-icon name="plus" [size]="30"></jam-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
